module.exports = __webpack_public_path__ + "static/media/chartDispositivos.bcac7c9c.png";